import {IssueStateIcons} from '@github-ui/issue-pr-state/Icons'
import {useGetHovercardAttributesForType} from '@github-ui/hovercards/use-get-hovercard-attributes-for-type'
import {ActionList, Button} from '@primer/react'
import {useState} from 'react'

import type {LinkedIssue} from '@github-ui/dotcom-schema/types/pull_requests/v1/development'
import {IssueState, IssueStateReason} from '@github-ui/dotcom-schema/types/pull_requests/v1/development'
import styles from './LinkedIssues.module.css'

const INITIAL_VISIBLE_COUNT = 5

type LinkedIssuesProps = {
  linkedIssues: LinkedIssue[]
}

export function LinkedIssues({linkedIssues}: LinkedIssuesProps) {
  const [expanded, setExpanded] = useState(false)
  const hasMore = linkedIssues.length > INITIAL_VISIBLE_COUNT
  const visibleIssues = expanded || !hasMore ? linkedIssues : linkedIssues.slice(0, INITIAL_VISIBLE_COUNT)

  return (
    <>
      <ActionList variant="full">
        {visibleIssues.map(issue => (
          <LinkedIssueRow key={issue.id} issue={issue} />
        ))}
      </ActionList>
      {hasMore && (
        <Button variant="invisible" size="small" aria-expanded={expanded} onClick={() => setExpanded(prev => !prev)}>
          {expanded ? 'See less' : 'See more'}
        </Button>
      )}
    </>
  )
}

function LinkedIssueRow({issue}: {issue: LinkedIssue}) {
  const getHovercardAttributesForType = useGetHovercardAttributesForType()
  const hovercardAttrs = getHovercardAttributesForType('issue', {
    owner: issue.repository?.owner ?? '',
    repo: issue.repository?.name ?? '',
    issueNumber: issue.number,
  })

  return (
    <ActionList.LinkItem href={issue.url} className={styles.linkItem} {...hovercardAttrs}>
      <ActionList.LeadingVisual>{getIssueIcon(issue)}</ActionList.LeadingVisual>
      <span className={styles.rowText}>
        {issue.title} <span className={styles.issueNumber}>#{issue.number}</span>
      </span>
    </ActionList.LinkItem>
  )
}

function getIssueIcon(issue: LinkedIssue) {
  const key =
    issue.state === IssueState.OPEN
      ? 'OPEN'
      : issue.stateReason === IssueStateReason.NOT_PLANNED
        ? 'NOT_PLANNED'
        : issue.stateReason === IssueStateReason.DUPLICATE
          ? 'DUPLICATE'
          : 'COMPLETED'
  const Icon = IssueStateIcons[key]
  return <Icon />
}
